import React from 'react';
import {
  IconClock, IconMapPin, IconPhone, IconMail, IconNavigation,
} from '@tabler/icons-react';
import TopBar from '../../components/layout/TopBar';
import { Button, Skeleton } from '../../components/common';
import BrandMark from '../../components/layout/BrandMark';
import { useClinic } from '../../context/ClinicContext';
import { openDirections } from '../../services/mapsService';
import { formatPhone } from '../../utils/format';

export default function ClinicInfoPage() {
  const { clinic } = useClinic();
  return (
    <div className="page page--with-footer clinic-info">
      <TopBar title="Clinic info" bordered />
      <div className="page__body u-stack-4">
        {!clinic ? <Skeleton count={3} height={110} /> : (
          <>
            <div className="clinic-info__hero">
              <BrandMark size="lg" />
              <h1 className="clinic-info__name">{clinic.name}</h1>
            </div>
            <section className="card card--pad">
              <h2 className="card__title">Opening hours</h2>
              {clinic.openingHoursDetail.map((h) => (
                <div key={h.days} className="hours-row">
                  <span className="u-muted">{h.days}</span>
                  <strong>{h.hours}</strong>
                </div>
              ))}
            </section>
            <section className="list-card">
              <div className="list-row">
                <span className="icon-tile"><IconMapPin size={20} /></span>
                <div className="list-row__body">
                  <p className="list-row__title">Address</p>
                  <p className="list-row__sub">{clinic.address}</p>
                </div>
              </div>
              <a className="list-row" href={`tel:${clinic.phone.countryCode}${clinic.phone.number}`}>
                <span className="icon-tile"><IconPhone size={20} /></span>
                <div className="list-row__body">
                  <p className="list-row__title">Phone</p>
                  <p className="list-row__sub link">{formatPhone(clinic.phone.countryCode, clinic.phone.number)}</p>
                </div>
              </a>
              {clinic.email && (
                <a className="list-row" href={`mailto:${clinic.email}`}>
                  <span className="icon-tile"><IconMail size={20} /></span>
                  <div className="list-row__body">
                    <p className="list-row__title">Email</p>
                    <p className="list-row__sub link">{clinic.email}</p>
                  </div>
                </a>
              )}
              <div className="list-row">
                <span className="icon-tile"><IconClock size={20} /></span>
                <div className="list-row__body">
                  <p className="list-row__title">Appointments</p>
                  <p className="list-row__sub">
                    {`Book up to ${Math.round(clinic.bookingWindowDays / 30)} months ahead. Changes allowed until ${clinic.cancellationCutoffHours} hours before your visit.`}
                  </p>
                </div>
              </div>
            </section>
          </>
        )}
      </div>
      {clinic && (
        <div className="sticky-footer">
          <Button block onClick={() => openDirections(clinic)}>
            <IconNavigation size={20} />
            Get directions
          </Button>
        </div>
      )}
    </div>
  );
}
